import config from "../../../helper/config";
import APIHandler from "../../../handlers/APIHandler";

export const DesignationService = {
  getAll,
  getAllDesignations,
  add,
  update,
  deleteDesignation,
};

async function getAll(limit, offset, search_term) {
  const configOptions = {
    method: "GET",
    headers: APIHandler.getHeader(config.azure_ad_config.apis.OAT.name),
  };
  const response = await fetch(
    `${config.oat_api_url}/manage/designations/getAll/${limit}/${offset}?search_term=${search_term}`,
    configOptions
  );
  return APIHandler.handleResponse(response);
}

async function getAllDesignations() {
  const configOptions = {
    method: "GET",
    headers: APIHandler.getHeader(config.azure_ad_config.apis.OAT.name),
  };
  const response = await fetch(
    `${config.oat_api_url}/manage/designations/getAllDesignations`,
    configOptions
  );
  return APIHandler.handleResponse(response);
}

async function add(newDesignation) {
  const configOptions = {
    method: "POST",
    headers: APIHandler.getHeader(config.azure_ad_config.apis.OAT.name),
    body: JSON.stringify(newDesignation),
  };

  const response = await fetch(
    `${config.oat_api_url}/manage/designations/add`,
    configOptions
  );
  return APIHandler.handleResponse(response);
}

async function update(designationItem, designationId) {
  const configOptions = {
    method: "PUT",
    headers: APIHandler.getHeader(config.azure_ad_config.apis.OAT.name),
    body: JSON.stringify(designationItem),
  };

  const response = await fetch(
    `${config.oat_api_url}/manage/designations/update/${designationId}`,
    configOptions
  );
  return APIHandler.handleResponse(response);
}

async function deleteDesignation(id) {
  const configOptions = {
    method: "DELETE",
    headers: {
      ...APIHandler.getHeader(config.azure_ad_config.apis.OAT.name),
      "Content-Type": "application/json",
    },
  };

  const response = await fetch(
    `${config.oat_api_url}/manage/designations/delete/${id}`,
    configOptions
  );
  return APIHandler.handleResponse(response);
}
